module.exports = __webpack_public_path__ + "img/sign.eb18805c.png";